import React from "react";
import type { ReactNode } from "react";
import classNames from "classnames";
import { EmailBuilderSettingsAccordionProvider } from "./EmailBuilderSettingsAccordionContext";
import { EmailBuilderSettingsAccordionSection } from "./EmailBuilderSettingsAccordionSection";
import "./emailBuilderSettingsAccordion.scss";

type EmailBuilderSettingsAccordionRootProps = {
  defaultExpandedSectionIds?: readonly string[];
  className?: string;
  nested?: boolean;
  children: ReactNode;
};

function EmailBuilderSettingsAccordionRoot(
  props: EmailBuilderSettingsAccordionRootProps,
): React.ReactElement {
  const { defaultExpandedSectionIds, className, nested = false, children } = props;

  return (
    <EmailBuilderSettingsAccordionProvider defaultExpandedSectionIds={defaultExpandedSectionIds}>
      <div
        className={classNames("email-builder-settings-accordion", className, {
          "email-builder-settings-accordion--nested": nested,
        })}
      >
        {children}
      </div>
    </EmailBuilderSettingsAccordionProvider>
  );
}

export const EmailBuilderSettingsAccordion = Object.assign(EmailBuilderSettingsAccordionRoot, {
  Section: EmailBuilderSettingsAccordionSection,
});
